<div class="calendar-header">
  <button
    mat-icon-button
    class="calendar-double-arrow"
    (click)="previousClicked('year')"
  >
  <span class="doubleArrows"><mat-icon>keyboard_arrow_left</mat-icon><mat-icon>keyboard_arrow_left</mat-icon></span>
  </button>

  <button mat-icon-button (click)="previousClicked('month')">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>

  <span class="calendar-header-label">{{ periodLabel }}</span>

  <button mat-icon-button (click)="nextClicked('month')">
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>

  <button
    mat-icon-button
    class="calendar-double-arrow"
    (click)="nextClicked('year')"
  >
    <span class="doubleArrows"><mat-icon>keyboard_arrow_right</mat-icon><mat-icon>keyboard_arrow_right</mat-icon></span>
  </button>
</div>
<div class="todayRow">
  <button class="today" mat-button (click)="todayClicked()">TODAY</button>
</div>
